import axios from 'axios';
import { reportError } from './reportError';


export const getAllIn = async ({ table }) => {
    // const table = props.table;
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        // if (data.exito === 1) {
        //     console.log(`registros recuperados de (${ table })`);
        // }
    })
    .catch( 
        err => console.log( `getAllIn|${ err }` )
        // err => reportError({ emailTo:"jcollins@cibnor.mx", values:{table}, task:"getAllIn|" + err }) 
    );

    return result;
}


export const getOneIn = async(props) => {
    const { table, id } = props;
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}/${id}`;

    var result = ['lol'];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("registro recuperado...");
        }
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{table, id}, task:"getOneIn|" + err }) );

    return result;
}



export const getOneInById = async(props) => {
    const { table, id } = props;
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}/${id}`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("getOneInById recuperado...");
        }
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{table, id}, task:"getOneInById|" + err }) );

    return result;
}


export const getOneInByParams = async(props) => {
    const { table, paramsNames, paramsValues } = props;

    let paramsStr = "";
    const paramsCount = paramsNames.length - 1;
    for (let index = 0; index <= paramsCount; index++) {
        paramsStr += `${paramsNames[index]}=${paramsValues[index]}`

        if (index < paramsCount) {
            paramsStr += "&"
        }
    }
    // console.log(paramsStr);
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}?${paramsStr}`;
    // console.log(url);
    // const url = `${process.env.REACT_APP_BASE_URL}/api/${table}?${paramName}=${paramValue}`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log(`getOneInByParam ${table} recuperado...`);
        }
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{paramsValues}, task:"crudCustom getOneInByParams|" + err }) )

    return result;
}


export const getOneInByReferencia = async(props) => {
    const { table, referencia } = props;
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}?referencia=${referencia}`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        // if (data.exito === 1) {
        //     console.log("getOneInByReferencia recuperado...");
        // }
    })

    return result;
}


export const getOneInByRefBancaria = async(props) => {
    const { table, refBancaria } = props;
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}?refBancaria=${refBancaria}`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("getOneInByRefBancaria recuperado...");
        }
    })

    return result;
}


export const getOneInByClave = async(props) => {
    const { table, clave } = props;
    // const url = `${process.env.REACT_APP_BASE_URL}/api/${table}?clave=${clave}`;
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}?clave=${clave}`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("getOneInByClave recuperado...");
        }
    })
    .catch( err => console.log(`${err}; params: ${table}, ${clave}`) );

    return result;
}


export const getOneInByTabla = async(props) => {
    const { table } = props;
    const url = `${process.env.REACT_APP_BASE_URL}/api/EventosConRegistro?tabla=${table}`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("getOneInByTabla recuperado...");
        }
    })
    .catch( err => console.log(`${err}; params: ${table}`) );

    return result;
}


export const postIn = async (props) => {
    
    const table = props.table;
    const values = { ...props.values };
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}`;

    var result = [];

    await axios.post(url, values)
    .then( response => {
        const data = response.data;
        result = {...data};
        if (data.exito === 1) {
            console.log("datos guardados...");
        }
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{table, values}, task:"postIn|" + err }) );

    return result;
}


export const putOneIn = async(props) => {

    const { table, values } = props;
    console.log(table, values);
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}/${values.id}`;


    var result = [];

    await axios.put(url, values)
    .then( response => {
        const data = response.data;
        result = {...data};
        if (data.exito === 1) {
            console.log("datos actualizados...");
        }
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{table, values}, task:"putOneIn|" + err }) );

    return result;
}


export const deleteOneIn = async(props) =>{

    const { table, id } = props;
    const url = `${process.env.REACT_APP_BASE_URL}/api/${table}/${id}`;

    var result = [];

    await axios.delete(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("registro eliminado...");
        }
    })
    .catch( err => reportError({ emailTo:"jcollins@cibnor.mx", values:{table, id}, task:"deleteOneIn|" + err }) );

    return result;
}